export default "__VITE_ASSET__DUSn6pwY__"